import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

import { useCustomToast } from 'hooks';

import { updateCalculation } from '../../api/updateCalculation';

export const useUpdateCalculationMutation = () => {
  const { t } = useTranslation();
  const { successToast, errorToast } = useCustomToast();

  return useMutation(updateCalculation, {
    onSuccess: response => {
      if (
        response?.reservationErrorsAndInfo?.errors ||
        response?.reservationErrorsAndInfo?.info[0]?.message
      ) {
        const error =
          response?.reservationErrorsAndInfo?.errors[0]?.message ||
          response?.reservationErrorsAndInfo?.info[0]?.message;
        errorToast(t(error));

        return;
      }

      successToast(t('Calculation saved successfully.'));
    },
  });
};
